var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin_favorite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CC4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_favorite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.565657, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0266299,40.8783784 C22.2543618,40.8783784 25.1423324,39.527027 25.4820937,40.2027027 C25.7086012,40.6531532 23.5567799,43.9189189 19.0266299,50 C14.49648,43.9189189 12.3446587,40.6531532 12.5711662,40.2027027 C12.9109275,39.527027 15.7988981,40.8783784 19.0266299,40.8783784 Z M18.6868687,-7.10542736e-15 C29.0073413,-7.10542736e-15 37.3737374,8.31903337 37.3737374,18.5810811 C37.3737374,28.8431288 29.0073413,37.1621622 18.6868687,37.1621622 C8.36639609,37.1621622 3.97903932e-13,28.8431288 3.97903932e-13,18.5810811 C3.97903932e-13,8.31903337 8.36639609,-7.10542736e-15 18.6868687,-7.10542736e-15 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-star",
    transform: "translate(11.000000, 12.000000)",
    fill: "#FFCE66",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.87797836,12.3919033 C3.15491125,12.5803733 3.50612634,12.5155879 3.92490089,12.2505479 L7.49793,9.95945989 L11.0777095,12.2505479 C11.4964702,12.5155879 11.8409349,12.5803733 12.1246182,12.3919033 C12.4015511,12.2093197 12.4623601,11.9089498 12.2934754,11.4848882 L10.8818231,7.8156113 L14.4885904,5.55987006 C14.907448,5.30071631 15.0762083,5.02390369 14.968174,4.73530641 C14.8601397,4.44670914 14.5426767,4.30536571 14.022563,4.311252 L9.59851163,4.34069553 L8.25440498,0.653752559 C8.09229826,0.223811855 7.84914509,0 7.49793,0 C7.15345149,0 6.91029832,0.223811855 6.7481916,0.653752559 L5.40408495,4.34069553 L0.980019758,4.311252 C0.459933701,4.30536571 0.142484504,4.44670914 0.0344225782,4.73530641 C-0.0804035923,5.02390369 0.0952039531,5.30071631 0.513978497,5.55987006 L4.1207735,7.8156113 L2.70912123,11.4848882 C2.5402641,11.9089498 2.6010593,12.2093197 2.87797836,12.3919033 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFavorite);
export default __webpack_public_path__ + "static/media/pin_favorite.d6afd6fb97376885d3d6e973291ddd88.svg";
export { ForwardRef as ReactComponent };